import { render, staticRenderFns } from "./OddsPreview.vue?vue&type=template&id=2c13fe3a&"
import script from "./OddsPreview.vue?vue&type=script&lang=js&"
export * from "./OddsPreview.vue?vue&type=script&lang=js&"
import style0 from "./OddsPreview.vue?vue&type=style&index=0&id=2c13fe3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports